'use strict';
(() => {
  const shell = document.querySelector('[data-bw-page-shell]');
  const rail = document.querySelector('[data-bw-cup-rail]');
  if (!shell || !rail) return;
  const main = document.getElementById('main');
  const mobile = matchMedia('(max-width: 950px)');
  const editorial = document.body.dataset.page === 'home' || document.body.dataset.layout === 'information';
  let relocatedHero = null;

  function restoreHero() {
    if (!relocatedHero?.isConnected) return;
    const image = relocatedHero.querySelector('.detail-image');
    const intro = relocatedHero.querySelector('.detail-intro');
    if (image && intro) intro.before(image);
    relocatedHero = null;
  }

  function placeRail() {
    // Move the same accessible banner; never duplicate links or element IDs.
    shell.append(rail);
    rail.classList.remove('bw-cup-mobile-in-content');
    restoreHero();
    const content = main.querySelector('.bw-browse-content, .bw-care-content');
    if (content) {
      content.prepend(rail);
      content.classList.add('bw-content-with-cup');
      rail.classList.toggle('bw-cup-mobile-in-content', mobile.matches);
      measureSticky(); return;
    }
    if (editorial) {
      const comparison = document.body.dataset.page === 'home' && main.querySelector('.bwh-comparison-opening');
      const comparisonSection = comparison && comparison.closest('.shopify-section');
      if (comparisonSection?.parentElement === main) {
        // The native comparison stays full width; the rail starts alongside Care.
        const sections = Array.from(main.children).filter(node => node.classList.contains('shopify-section'));
        comparisonSection.after(rail);
        main.style.setProperty('--bw-content-rows', sections.length);
        main.style.setProperty('--bw-rail-row', sections.indexOf(comparisonSection) + 2);
        main.classList.add('bw-reading-grid');
        rail.classList.toggle('bw-cup-mobile-in-content', mobile.matches);
        measureSticky();
        return;
      }
      const opening = main.querySelector('.bw-product-opening, .detail-hero, .stage-strip') || main.querySelector('.hero');
      const section = opening?.closest('.shopify-section');
      const sections = Array.from(main.children).filter(node => node.classList.contains('shopify-section'));
      if (section && sections.includes(section)) {
        // One real main landmark, with full-width opening rows and a reading rail.
        section.after(rail);
        main.style.setProperty('--bw-content-rows', sections.length);
        main.style.setProperty('--bw-rail-row', sections.indexOf(section) + 2);
        main.classList.add('bw-reading-grid');
        rail.classList.toggle('bw-cup-mobile-in-content', mobile.matches);
        const hero = main.querySelector('.detail-hero');
        if (mobile.matches && hero) {
          const intro = hero.querySelector('.detail-intro');
          if (intro) { hero.prepend(intro); relocatedHero = hero; }
        }
        measureSticky();
        return;
      }
      main.classList.remove('bw-reading-grid');
    }
    if (mobile.matches) {
      const hero = main.querySelector('.detail-hero');
      const intro = hero?.querySelector('.detail-intro');
      if (intro) {
        hero.prepend(intro);
        intro.after(rail);
        relocatedHero = hero;
      } else {
        const opening = main.querySelector('.hero, .editorial-hero, .service-page-hero, .signup-intro');
        if (opening) opening.after(rail);
        else {
          const heading = main.querySelector('h1');
          const next = heading?.nextElementSibling;
          if (heading) (next?.matches('p, .state-intro, .bw-copy') ? next : heading).after(rail);
        }
      }
      if (rail.parentElement !== shell) rail.classList.add('bw-cup-mobile-in-content');
    }
    measureSticky();
  }

  function measureSticky() {
    const header = document.querySelector('.bw-shopify-header');
    const top = (header?.getBoundingClientRect().height || 0) + 24;
    shell.style.setProperty('--bw-cup-top', top + 'px');
    const card = rail.querySelector('.bw-cup-sticky');
    rail.classList.toggle('bw-cup-too-tall', !!card && card.getBoundingClientRect().height + top + 24 > window.innerHeight);
  }

  mobile.addEventListener('change', placeRail);
  window.addEventListener('resize', measureSticky, { passive: true });
  document.addEventListener('shopify:section:unload', event => {
    // Keep the banner alive if the editor replaces the section containing it.
    if (event.target.contains(rail)) {
      shell.append(rail);
    }
    requestAnimationFrame(placeRail);
  });
  document.addEventListener('shopify:section:load', placeRail);
  document.addEventListener('shopify:section:reorder', placeRail);
  if (window.ResizeObserver) {
    const observer = new ResizeObserver(measureSticky);
    observer.observe(rail.querySelector('.bw-cup-sticky'));
    const header = document.querySelector('.bw-shopify-header');
    if (header) observer.observe(header);
  }
  placeRail();
})();
